import { ICities, IThemes, ISelectOptions } from '../interfaces/common';

export const convertToSelectOptions = (
  incomingArray: IThemes[] | ICities[],
): ISelectOptions[] =>
  incomingArray.map((item) => ({
    value: item.id,
    label: item.title,
  }));
